import { render, staticRenderFns } from "./ViewBox.vue?vue&type=template&id=0768ba6c&scoped=true&"
import script from "./ViewBox.vue?vue&type=script&lang=js&"
export * from "./ViewBox.vue?vue&type=script&lang=js&"
import style0 from "./ViewBox.vue?vue&type=style&index=0&id=0768ba6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768ba6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VContent,VIcon,VSlideYReverseTransition,VSpacer,VToolbarTitle})
